import {
  COLUMN_NAMES,
  DEFAULT_EMAIL_DATE_LOCALE,
  EMAIL_DATE_LOCALES,
  EMPTY_VALUE_PLACEHOLDER,
  INVOICE_FILE_TYPES,
  REASON_CODE_KEYS,
  REASON_COLUMN_NAMES,
  TRANSLATION_KEYS,
} from './constants';

export const isInvoiceFileType = (fileType) => INVOICE_FILE_TYPES.includes(fileType);

export const isEmptyValue = (value) => value === null || value === undefined || value === '';

export const isReasonColumn = (columnName) => REASON_COLUMN_NAMES.includes(columnName);

export const isValidDateRange = (from, to) => {
  if (!from || !to) return false;

  const fromTime = new Date(from).getTime();
  const toTime = new Date(to).getTime();

  if (Number.isNaN(fromTime) || Number.isNaN(toTime)) return false;

  return toTime >= fromTime;
};

export const formatDate = (value, language) => {
  if (!value) return EMPTY_VALUE_PLACEHOLDER;

  try {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    const locale = EMAIL_DATE_LOCALES[language] || DEFAULT_EMAIL_DATE_LOCALE;

    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(date);
  } catch {
    return value;
  }
};

export const getReasonTranslationKey = (code, fileType) => {
  const reasonEntry = REASON_CODE_KEYS[code];
  if (!reasonEntry) return null;

  if (reasonEntry.default) return reasonEntry.default;

  return isInvoiceFileType(fileType) ? reasonEntry.invoice : reasonEntry.receipt;
};

export const normalizeValue = ({ value, columnName, row, t, language }) => {
  if (isEmptyValue(value)) return EMPTY_VALUE_PLACEHOLDER;

  if (typeof value === 'boolean') {
    return value ? t(TRANSLATION_KEYS.true) : t(TRANSLATION_KEYS.false);
  }

  if (columnName === COLUMN_NAMES.emailDate) {
    return formatDate(value, language);
  }

  if (isReasonColumn(columnName) && typeof value === 'string') {
    const key = getReasonTranslationKey(value, row && row.fileType);
    return key ? t(key) : value;
  }

  return String(value);
};

export const buildAccordionKey = (emailItem, index) => {
  const datePart = emailItem.emailDate || 'date';
  const senderPart = emailItem.senderAddress || 'sender';

  return `${datePart}-${senderPart}-${index}`;
};

export const buildEmailTitle = (emailItem, index, t) => {
  const titleParts = [
    t(TRANSLATION_KEYS.emailTitle, { index: index + 1 }),
    emailItem.senderAddress,
    emailItem.fileType,
    emailItem.fileNumber,
  ].filter(Boolean);

  return titleParts.join(' — ');
};

export const buildRangeLabel = (range, language, t) => {
  const fromLabel = formatDate(range.from, language);
  const toLabel = formatDate(range.to, language);

  return `${t(TRANSLATION_KEYS.rangeLabel)}: ${fromLabel} - ${toLabel}`;
};
